/**
 * Error codes for Hogeschooltaal - Users API
 */
module.exports = {
  DUPLICATED_STUDENT_NUMBER: 'E-HST-USR-DSTNM',
};
